import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Stack,
  Box
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import ShowContainer from '../material-ui/ShowContainer';
import { IconX } from '@tabler/icons-react';
import ErrorBoundary from '../material-ui/error_boundary/ErrorBoundary';

export default function InfoDialog({
  open,
  onClose,
  onCloseClick,
  closeText = 'Close',
  onSaveClick,
  title = '',
  infoText = '',
  infoJSX = <></>,
  children,
  hideButtons,
  saveText = 'Save',
  contentSx,
  actions = <></>,
  maxWidth = 'sm'
}) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      <DialogTitle>
        <Stack display={'flex'} direction={'row'} justifyContent={'space-between'}>
          <Typography fontSize={20} fontWeight={600}>
            {t(title)}
          </Typography>

          <Box title={t('Close')} sx={{ '& svg:hover': { color: 'primary.main' } }}>
            <IconX onClick={onClose} size={18} style={{ cursor: 'pointer' }} />
          </Box>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ opacity: open ? 1 : 0, ...contentSx }}>
        {infoText && <Typography variant="body1">{infoText}</Typography>}
        <ErrorBoundary>{children || infoJSX}</ErrorBoundary>
      </DialogContent>
      <ShowContainer condition={!hideButtons}>
        <DialogActions>
          {actions}
          <ShowContainer condition={onSaveClick}>
            <Button variant="contained" onClick={onSaveClick}>
              {t(saveText)}
            </Button>
          </ShowContainer>
          <Button variant="outlined" onClick={onCloseClick || onClose}>
            {t(closeText)}
          </Button>
        </DialogActions>
      </ShowContainer>
    </Dialog>
  );
}
